import script from "./VariantCard.vue?vue&type=script&setup=true&lang=js"
export * from "./VariantCard.vue?vue&type=script&setup=true&lang=js"

import "./VariantCard.vue?vue&type=style&index=0&id=7e7c8ff9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e7c8ff9"]])

export default __exports__